var React = require('react');

function PortfolioAnalysis (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 81H82","stroke":"#0A433E","strokeWidth":"3","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M6.28577 41.7143H17.0001V71.7143H6.28577V41.7143Z","stroke":"#0A433E","strokeWidth":"3","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M27 24.5714H37V71.7143H27V24.5714Z","stroke":"#0A433E","strokeWidth":"3","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M47 33.8571H57.7143V71.7143H47V33.8571Z","stroke":"#0A433E","strokeWidth":"3","strokeLinecap":"round","key":3}),React.createElement("path",{"d":"M67 2.42856H77.7143V71.7143H67V2.42856Z","stroke":"#0A433E","strokeWidth":"3","strokeLinecap":"round","key":4})]);
}

PortfolioAnalysis.defaultProps = {"width":"84","height":"83","viewBox":"0 0 84 83","fill":"none"};

module.exports = PortfolioAnalysis;

PortfolioAnalysis.default = PortfolioAnalysis;
